export default import.meta.ROLLDOWN_FILE_URL_i_yBH7uydOoM63K_K2S1vA